import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BASE_URL } from "../api/api";
import { AuthContext } from "../context/AuthContext";

export default function LogPage() {
    const { batchNo } = useParams();
    const navigate = useNavigate();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useContext(AuthContext);
    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const response = await fetch(
                    `${BASE_URL}/GetBatchLogs`
                );
                const data = await response.json();

                if (data.status && data.dataItems) {
                    const filteredLogs = data.dataItems.filter(
                        (item) => item.batchNo === batchNo
                    );
                    setLogs(filteredLogs);
                }
            } catch (error) {
                console.error("Error fetching logs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchLogs();
    }, [batchNo]);
    const formatTime12Hour = (dateTimeStr) => {
        if (!dateTimeStr) return "-";

        const timePart = dateTimeStr.split(" ")[1];
        if (!timePart) return "-";

        const [hours, minutes, seconds] = timePart.split(":").map(Number);
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;

        return `${hour12}:${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")} ${ampm}`;
    };

    return (
        <div className="container mt-4">
            <div className="p-6 bg-gray-50 min-h-screen">
                <button
                    className="btn btn-primary d-flex align-items-center"
                    style={{
                        backgroundColor: "#8000d7",
                        border: "none",
                        padding: "10px 16px",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "14px",
                    }}
                    onClick={() => navigate(-1)}
                >
                    Back
                </button>
                <h3 className="text-2xl font-bold text-gray-800 mb-6 my-4">
                    Batch Logs <span className="text-gray-500">#{batchNo}</span>
                </h3>

                {loading ? (
                    <p className="text-gray-600 italic">Loading logs...</p>
                ) : logs.length === 0 ? (
                    <p className="text-red-500 font-medium">Batch Created.</p>
                ) : (
                    <div className="overflow-x-auto shadow-md rounded-2xl border border-gray-200">
                        <table className="min-w-full bg-gray-100 table table-stripped">
                            <thead className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-t-2xl">
                                <tr>
                                    <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                                        S.no
                                    </th>
                                    <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                                        Logs
                                    </th>
                                    <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                                        By Whom
                                    </th>
                                    <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                                        Created Date
                                    </th>
                                    <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                                        Time
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log, index) => (
                                    <tr
                                        key={index}
                                        className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                                            } hover:bg-blue-50 transition`}
                                    >
                                        <td className="py-3 px-4 text-gray-700 font-medium">
                                            {/* {index + 1} */}
                                            {logs.length - index}
                                        </td>
                                        <td className="py-3 px-4">
                                            <span className="inline-block px-2 py-1 text-xs font-medium rounded-lg bg-blue-100 text-blue-700">
                                                {log.remarks}
                                            </span>
                                        </td>
                                        <td className="py-3 px-4 text-gray-700 font-medium">
                                            {log.byWhom ? log.byWhom : user.role}
                                        </td>
                                        <td className="py-3 px-4 text-gray-500 text-sm">
                                            {log.created_Date.split(" ")[0]}
                                        </td>
                                      <td>{formatTime12Hour(log.created_Date)}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                )}
            </div>
        </div>
    );
}
